export default {
  tradeinValue: {
    id: 'trade_in_au_offer_value',
    defaultMessage: 'Trade-in value',
  },
  bestTimeToSell: {
    id: 'trade_in_au_offer_best_time_to_sell',
    defaultMessage: 'Best time to sell - value decreases over time',
  },
  circularity: {
    id: 'trade_in_au_offer_circularity',
    defaultMessage: 'Keeps valuable resources in circulation',
  },
  recycleForFree: {
    id: 'trade_in_au_recycle_for_free',
    defaultMessage:
      'This device does not qualify for a Trade-in value, however we can recycle it for free.',
  },
  shipping: {
    id: 'trade_in_au_offer_shipping',
    defaultMessage: 'Free & insured shipping',
  },
}
